import React from "react";

import AiInterviewerCreateView from "../../AiInterviewerCreate/AiInterviewerCreateView";
import { AgenticIntakeCreateView } from "../AgenticIntake";
import { useAgenticIntakeEnabled } from "../AgenticIntake/useAgenticIntakeEnabled";
import { AiInterviewerCreateViewFlexIntake } from "./AiInterviewerCreateViewFlexIntake";
import { useFlexIntakeEnabled } from "./useFlexIntakeEnabled";

/**
 * Forks between legacy, flex intake, and agentic intake create flows.
 * Priority: agentic_intake > flex_intake > legacy.
 */
const AiInterviewerCreateViewFork: React.FC = () => {
  const agenticIntakeEnabled = useAgenticIntakeEnabled();
  const flexIntakeEnabled = useFlexIntakeEnabled();

  if (agenticIntakeEnabled) {
    return <AgenticIntakeCreateView />;
  }

  if (flexIntakeEnabled) {
    return <AiInterviewerCreateViewFlexIntake />;
  }

  return <AiInterviewerCreateView />;
};

export { AiInterviewerCreateViewFork };
